import {FullGameDomainModel} from "./full-game-domain-model";
import {FullGameResponseApiModel} from "./full-game-response-api-model";
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {BookmakerDomainModel} from "../../common/bookmaker/models/bookmaker-domain-model";

export class FullGameDataSource extends BaseDomainDataSource {
  game: FullGameDomainModel;
  bookmakers: Array<BookmakerDomainModel>;

  constructor(game: FullGameDomainModel, apiModel: FullGameResponseApiModel, bookmakers: Array<BookmakerDomainModel>) {
    super(apiModel);

    this.game = game;
    this.bookmakers = bookmakers;
  }
}
